var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.display
    ? _c("div", { staticClass: "property-select-multiple" }, [
        _c("div", {
          staticClass: "property-select-multiple__icon",
          class: _vm.icon,
          attrs: { title: _vm.readableName }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "property-select-multiple__input",
            class: {
              "property-select-multiple__input--readonly": _vm.isReadOnly
            }
          },
          [
            !_vm.isReadOnly
              ? _c("Multiselect", {
                  attrs: {
                    options: _vm.options,
                    searchable: true,
                    placeholder: _vm.placeholder,
                    "tag-placeholder": _vm.tagPlaceholder,
                    "allow-empty": true,
                    title: _vm.readableName,
                    value: _vm.value,
                    multiple: true,
                    taggable: true
                  },
                  on: {
                    select: _vm.selectValue,
                    tag: _vm.selectValue,
                    remove: _vm.unselectValue
                  },
                  scopedSlots: _vm._u(
                    [
                      _vm.coloredOptions
                        ? {
                            key: "tag",
                            fn: function(scope) {
                              return [
                                _c(
                                  "PropertySelectMultipleColoredTag",
                                  _vm._b(
                                    {},
                                    "PropertySelectMultipleColoredTag",
                                    scope,
                                    false
                                  )
                                )
                              ]
                            }
                          }
                        : null,
                      _vm.coloredOptions
                        ? {
                            key: "option",
                            fn: function(scope) {
                              return [
                                _c(
                                  "PropertySelectMultipleColoredOption",
                                  _vm._b(
                                    {},
                                    "PropertySelectMultipleColoredOption",
                                    scope,
                                    false
                                  )
                                )
                              ]
                            }
                          }
                        : null
                    ],
                    null,
                    true
                  )
                })
              : _c(
                  "div",
                  {
                    staticClass: "property-select-multiple-colored-tag-wrapper"
                  },
                  _vm._l(_vm.value, function(singleValue) {
                    return _c("PropertySelectMultipleColoredTag", {
                      key: singleValue,
                      attrs: { option: singleValue }
                    })
                  }),
                  1
                )
          ],
          1
        ),
        _vm._v(" "),
        _vm.hasInfo
          ? _c("div", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.info,
                  expression: "info"
                }
              ],
              staticClass: "property-select-multiple__info icon-details"
            })
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }